import React from 'react'
import Hero from './Hero'
import Header from './Header'
import Header2 from './Header2'
import About from './About'
import Experience2 from './Experience2'
import WelcomePage from './WelcomePage'
import { useState,useEffect } from 'react'
import Features from './Featrures'
import Skills from './Skills'
import TrainingExperience from './TrainingExperience'
import Education from './Education'
import SoftWares from './SoftWares'
import CarouselSoftWares from './Softwares2'
import ScanToBimProjects from './ScanToBimProjects'
import CoverLetterImg from '../Images/coverLetterImg.png';
import { useNavigate } from 'react-router-dom'
import ResponsiveVideos from './IntroContainers'
import OtherSkills from './OtherSkills'

const LandingPage = () => {
  const navigate = useNavigate();
  const [switchWelcome,setSwitchWelcome]=useState(true)
  useEffect(() => {
      const timeoutId1 = setTimeout(() => {
          setSwitchWelcome(true);
      }, 100);

      const timeoutId2 = setTimeout(() => {
          setSwitchWelcome(false);
      }, 3000);

      return () => {
          clearTimeout(timeoutId1);
          clearTimeout(timeoutId2);
      };
  }, []);
  return (
    <div>

        
      <Hero/>
      <About/>
      <ResponsiveVideos/>
      {/* <Features/> */}
      {/* <Skills/> */}
      <OtherSkills/>
      <Experience2/>
      <SoftWares/>
      <CarouselSoftWares/>
      <ScanToBimProjects/>
      
      <Education/>
      <TrainingExperience/>
      {/* <img src={CoverLetterImg} alt="coverletterImg" className="CoverLetterImg" onClick={()=>navigate("/coverletter")}/> */}
      
      {switchWelcome&&<WelcomePage/>}
      
    </div>
  )
}

export default LandingPage
